// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChoicesController from "./choices_controller"
application.register("choices", ChoicesController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DynamicListController from "./dynamic_list_controller"
application.register("dynamic-list", DynamicListController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MoneyController from "./money_controller"
application.register("money", MoneyController)

import PageSizeController from "./page_size_controller"
application.register("page-size", PageSizeController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import ProfitCalculatorController from "./profit_calculator_controller"
application.register("profit-calculator", ProfitCalculatorController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)
